import http from '../client'
import type { PaginationData } from '../base.d'
import type { EmployeeSeat, OrgSeat, SeatType } from './seat.d'

export function listEmployeeSeat() {
  return http<PaginationData<EmployeeSeat>>({
    url: '/ram/api/employee-seat/list-employee-seat-by-page',
    data: { pageIndex: 1, pageSize: 100 },
  })
}

export function getCurrentSeat() {
  return http<OrgSeat>({
    url: '/ram/api/organization-seat/get-current-seat',
  })
}

export function updateEmployeeSeat(data: { employeeId: number; seatType: SeatType }) {
  return http<EmployeeSeat>({
    url: '/ram/api/employee-seat/update-employee-seat',
    data,
    hideToast: true,
  })
}

export function updateOrganizationMemberQuantity(data: {
  organizationId: number
  memberQuantity: number
}) {
  return http<EmployeeSeat>({
    url: '/ram/api/platform-organization/update-organization-member-quantity',
    data,
    hideToast: true,
  })
}

export function forceExitOnlineSeat(employeeId: number) {
  return http<PaginationData<EmployeeSeat>>({
    url: '/ram/api/employee-seat/force-exit-online-seat',
    data: { employeeId },
  })
}

export function exitOnlineSeat() {
  return http<PaginationData<EmployeeSeat>>({
    url: '/ram/api/employee-seat/exit-online-seat',
  })
}

export function getOrganizationSeatById(id: number) {
  return http<OrgSeat>({
    url: '/ram/api/organization-seat/get-organization-seat-by-id',
    params: { id },
  })
}

export function queryOrganizationSeat(organizationId: number) {
  return http<PaginationData<OrgSeat>>({
    url: '/ram/api/organization-seat/query-organization-seat',
    data: { organizationId, pageIndex: 1, pageSize: 10 },
  })
}

export function updateOrganizationAccountSeatType(data: {
  organizationId: number
  accountSeatType: string
}) {
  return http({
    url: '/ram/api/platform-organization/update-organization-account-seat-type',
    data,
  })
}

export function updateOrganizationSeat(data: any) {
  return http({
    url: '/ram/api/organization-seat/update-organization-seat',
    data,
  })
}
